import { Component } from "react";

import PayementService from "../../../services/Payement";
import uploadAndDownloadService from "../../../services/uploadAndDownloadFile";
import UtilsUrl from "../../../utils/UtilsUrl";
import UtilsFormule from "../../../utils/UtilsFormule";
import UtilsFormuleSell from "../../../utils/UtilsFormuleSell";
class ChequePayementDetail extends Component {
  state = {
    payement: "",
    banque: "",
    agence: "",
  };

  constructor(props) {
    super(props);

    this.state = {
      payement: "",
      banque: "",
      agence: "",
    };
  }



  onShowFileInOtherWizndowHandler = (path) => {
    uploadAndDownloadService
      .downloadFile(path)
      .then((response) => {
        // let index = path.lastIndexOf(".");
        // let extension = path.substr(index + 1);

        //Build a URL from the file
        if (response.headers["content-type"] === "image/png") {
          const file = new Blob([response.data], { type: "image/png" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "application/pdf") {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpeg") {
          const file = new Blob([response.data], { type: "image/jpeg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpg") {
          const file = new Blob([response.data], { type: "image/jpg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        }
      })
      .catch(() => {
        // setOpenErrorAlert(true);
        // setErrorAlertText("Erreur : il ya un probléme de connection");
      });
  };
  
  render() {
    return (
      <div className="row">
        <div className="user-block">
          {/* <span className="description"> */}
          Payement par <b>Chèque / Traite</b>{" "}
          {this.props.payementAvance?.codeCheque} le :{" "}
          {UtilsFormule.formatDate(this.props.payementAvance?.creationDate)}
          {this.props.payementAvance?.urlFile !== "any" && (
            <button
              // href={this.props.payementAvance?.urlFile}
              className="link-black text-sm float-right"
              style={{ backgroundColor: "white", border: "none" }}
              onClick={() =>
                this.onShowFileInOtherWizndowHandler(
                  UtilsUrl.fileRetailURL() + this.props.payementAvance?.urlFile
                )
              }
            >
              <i className="fas fa-link mr-1" /> fichier
            </button>
          )}
          <br />
          <b>RIB</b>:{" "}
          {this.props.payementAvance?.banqueAccount.bankAccountNumber}-
          {this.props.payementAvance?.banqueAccount.agence.agenceName}-
          {this.props.payementAvance?.banqueAccount.agence.banque.nameBanque}
          <br />
          {/* <span className="description"> */}
          Montant payée:{this.props.payementAvance?.amountPayed} TND
          {/* </span> */}
          <br />
          Date d'écheance: {UtilsFormule.formatDate(this.props.payementAvance?.echeanceDate)}
          <br />
          {UtilsFormuleSell.TypePayementValidation(this.props.payementAvance)}
          <br />
          {/* <span className="description"> */}
          {/* </span> */}
        </div>
      </div>
    );
  }
}
export default ChequePayementDetail;
